import { useState, useEffect } from 'react';

export const useSafeDataFetch = (url, options = {}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const response = await fetch(url, {
                    method: 'GET',
                    ...options
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const result = await response.json();
                
                // Validar que el resultado sea válido
                if (result && typeof result === 'object') {
                    setData(result);
                } else {
                    setData(null);
                }
                
            } catch (err) {
                console.error('Error fetching data:', err);
                setError(err);
                setData(null);
            } finally {
                setLoading(false);
            }
        };

        if (url) {
            fetchData();
        } else {
            setLoading(false);
        }
    }, [url]);

    return { data, loading, error };
};

export default useSafeDataFetch;
